import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { TOnClick } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { observer } from "mobx-react"
import React, { useEffect, useState } from "react"

interface Props {
	defaultSelected?: boolean
	selected?: boolean
	onClick?: TOnClick
	children?: React.ReactNode
}

/**
 * Uses personalization configuration to show a custom
 * tab selection button.
 */
const PreferencesNavBarTabSelectionButton = observer(
	({ defaultSelected = false, selected: controlledSelected = false, onClick, children }: Props) => {
		const formStore = useFormStore()
		const [selected, setSelected] = useState<boolean>(defaultSelected)

		// Keep in sync with external state, if provided
		useEffect(() => {
			setSelected(controlledSelected)
		}, [controlledSelected])

		return (
			<HyperDiv
				className={concatWithSpaces("non-draggable", onClick ? "pointer" : "")}
				style={{
					height: 40,
					padding: "0 16px",
					backgroundColor: selected ? formStore.settingsData.personalize.colorButton : undefined,
					color: selected
						? formStore.settingsData.personalize.colorButtonText
						: formStore.settingsData.personalize.colorButton,
					borderRadius: "0px 0px 5px 5px",
					fontSize: 12,
					fontWeight: "bold",
					lineHeight: "145%",
					transition: "0.2s var(--default-slide-transition-fn)",
					transitionProperty: "background-color",
					filter: "brightness(110%) contrast(120%)",
				}}
				centered
				onClick={(e) => {
					setSelected((selected) => (controlledSelected ? controlledSelected : !selected))
					onClick && onClick(e)
				}}
				children={children}
			/>
		)
	}
)

export default PreferencesNavBarTabSelectionButton
